
import { motion } from "framer-motion"

export function PopularPackagesHeader() {
  return (
    <div className="text-center">
      {/* Badge */}
      <motion.div
        className="mb-6"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <span className="inline-block px-5 py-1.5 bg-[#ef483d] bg-opacity-10 rounded-full text-[#ef483d] text-sm font-medium">
          Popular Packages
        </span>
      </motion.div>

      {/* Main heading with increased spacing */}
      <motion.h2
        className="text-3xl md:text-5xl font-bold tracking-tight mb-5 text-[#1d1d1f]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        Get Started With These Popular Packages
      </motion.h2>

      {/* Subheading as a separate element */}
      <motion.p
        className="text-xl md:text-2xl text-[#424245] mb-6"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        For Efficient, AI-Powered Data Security
      </motion.p>
    </div>
  )
}
